import React, { memo } from 'react';
import PropTypes from 'prop-types';

import modalButton from 'constants/data-shapes/modal-button';
import { ModalCloseOptions } from 'constants/modalCloseOptions';

import { Modal } from '@johnlewispartnership/wtr-ingredients/ingredients/Modal';

const deleteButtonModalDefaultPropButtons = [
  {
    buttonText: 'Delete',
    buttonValue: ModalCloseOptions.OK,
  },
  {
    buttonText: 'Cancel',
    buttonValue: ModalCloseOptions.CANCEL,
  },
];

const deleteButtonModalDefaultPropCloseModal = () => {};

const DeleteButtonModal = memo(
  ({
    buttons = deleteButtonModalDefaultPropButtons,
    children,
    closeModal = deleteButtonModalDefaultPropCloseModal,
    isOpen = false,
    modalMessage = 'Delete',
  }) => (
    <Modal
      buttons={buttons}
      handleModalClose={closeModal}
      isOpen={isOpen}
      titleText={modalMessage}
      dataTest="delete-modal"
    >
      {children}
    </Modal>
  ),
);

DeleteButtonModal.displayName = 'DeleteButtonModal';

DeleteButtonModal.propTypes = {
  buttons: PropTypes.arrayOf(modalButton()),
  children: PropTypes.node,
  closeModal: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default DeleteButtonModal;
